import { Node } from "@xyflow/react";

export enum DecisionResult { // TODO (CTRL-14): This type is likely to change depending on what comes from the Acorn API
  Yes = "Yes",
  No = "No",
  DontKnow = "DontKnow",
}

// TODO (CTRL-14): Use the type that comes back from the Acorn API instead
export type LogicalConnector = "AND" | "OR";
export type LogicalOperator = "NOT";
export type UnderstandingRepresentation = {
  name: string;
  question: string;
  line?: string;
  logicalConnective?: LogicalConnector;
  logicalOperator?: LogicalOperator;
  subConditions?: UnderstandingRepresentation[];
};

export type BaseNodeData = {
  label: string;
  question: string;
  line?: string;
  isNegated: boolean;
  value: DecisionResult;
};

export type LeafConditionNode = Node<BaseNodeData, "leafCondition">;
export type LogicalConnectorNode = Node<
  BaseNodeData & { logicalConnector: LogicalConnector },
  "logicalConnector"
>;
export type AppNode = LeafConditionNode | LogicalConnectorNode;
